export default __webpack_public_path__ + "static/media/metabase_logo.1555d76a.png";